import { Component, OnInit } from '@angular/core';
import { FormArray, FormControl, FormGroup } from '@angular/forms';
import { ModalController, NavParams } from '@ionic/angular';
import { ENUMTypeDocumentVerification } from '@modals/select-file-upload/select-file-upload.component';
import { EnumPageRow, EnumWalletModules } from '@models/Common';
import { IFileModel } from '@models/Common';
import { EnumGenericRoleActionAlerts } from '@pages/BasePage';
import { FileService } from '@services/file.service';
import { environment } from '@environments/environment';

@Component({
    selector: 'app-import-householders-users',
    templateUrl: './import-householders-users.component.html',
    styleUrls: ['./import-householders-users.component.scss'],
})
export class ImportHouseholdersUsersComponent implements OnInit {

    private onChange: Function;
    private onUpload: Function;

    private onLoad: Function;

    public File: IFileModel;
    public FileTemplate: string;
    public Modules: { Id: number, Name: string }[] = [];

    public SelectedModule: { Id: number, Name: string } = null;

    public FileFormatsAllowed: string = environment.FileImports.SpreadsheetFormats.join(',');
    public Title: string = '';

    public Campaigns: any[] = [];

    public Form: FormGroup;

    public ProcessList: any[] = [];
    public PagedProcessList: any[] = [];

    public PageNumber: number = 1;
    public PageRows: number = EnumPageRow.R25;

    public ViewDocument: boolean = false;

    public ExcelData: any[][] = [];

    public Errors: string;

    public ValueErrors: { row: number; col: number; message: string }[] = [];
    public CellErrorsMap: Map<string, string> = new Map();

    public TypeDocumentVerification: ENUMTypeDocumentVerification;

    constructor(
        private NavParams: NavParams,
        private ModalController: ModalController,
        private FileService: FileService
    ) {

        this.Title = this.NavParams?.get('title') || null;
        this.onChange = this.NavParams?.get('onChange') || null;
        this.onLoad = this.NavParams?.get('onLoad') || null;
        this.onUpload = this.NavParams?.get('onUpload') || null;
        this.FileTemplate = this.NavParams?.get('fileTemplate') || '';
        this.Modules = this.NavParams?.get('modules') || [];
        this.Campaigns = this.NavParams?.get('campaigns') || [];
        this.TypeDocumentVerification = this.NavParams?.get('typeVerification') || this.TypeDocumentVerification;
        this.ViewDocument = this.NavParams?.get('viewDocument') || this.ViewDocument;

        this.FileFormatsAllowed = this.NavParams?.get('formatsAllowed') || this.FileFormatsAllowed;

        console.log(this.Modules);

        if (this.Modules?.length == 1)
            this.SelectedModule = this.Modules[0];


        this.Form = new FormGroup({
            Campaigns: new FormArray(this.Campaigns.map(it => new FormGroup({
                Id: new FormControl(it.Id),
                Checked: new FormControl(false)
            })))
        })
    }

    async ngOnInit() {

        if (this.onLoad)
            this.ProcessList = await this.onLoad();

        this.ApplyPagination();
    }

    async OnRefresh(ev?: any) {

        if (this.onLoad)
            this.ProcessList = await this.onLoad();

        this.PageNumber = 1;
        this.ApplyPagination();
    }

    OnChangePage(ev: { page: number, itemsPerPage: number }) {

        this.PageNumber = ev.page;
        this.PageRows = ev.itemsPerPage;

        this.ApplyPagination();
    }

    private ApplyPagination() {

        const start = (this.PageNumber - 1) * this.PageRows;

        this.PagedProcessList = (this.ProcessList || []).slice(start, start + this.PageRows);
    }


    get Checkboxes(): FormArray | any {
        return this.Form.get('Campaigns') as FormArray;
    }

    async OnChangeFile(file: any) {

        if (file?.files?.length == 0) return;

        if (this.onChange)
            this.File = await this.onChange(file);
        
        this.ExcelData = [];
        this.ValueErrors = [];
        this.CellErrorsMap = new Map();

        if (this.File && this.ViewDocument) {

            this.ExcelData = await this.FileService.ReadExcelFile(file?.files[0]);

            if (this.ExcelData?.length > 2) {

                let errors;

                switch (this.TypeDocumentVerification) {

                    case ENUMTypeDocumentVerification.HouseHolders:

                        errors = this.FileService.ValidateStructureForConsumerHouseHoldersFile(this.ExcelData);

                        console.log(errors);

                        if (errors?.isValid !== false) {

                            this.ValueErrors = this.FileService.ValidateConsumerHouseHoldersFileValues(this.ExcelData);
                            this.CellErrorsMap = new Map(this.ValueErrors.map(it => [`${it.row}_${it.col}`, it.message]));
                        }

                        break;

                    default:
                        break;
                }

                if (errors?.isValid === false) {
                    this.ExcelData = [];
                    this.Errors = "O ficheiro não é válido, utilize a estrutura do \"ficheiro template\".";
                    this.File = null;
                    return
                }

            }
        }


    }

    async OnUploadFile() {

        console.log(this.SelectedModule);

        const campaigns = (this.Form.get('Campaigns').value || [])?.filter(it => it?.Checked)?.map(i => i.Id);


        console.log(campaigns);


        if (this.onChange) {
            const response = await this.onUpload(this.File, EnumWalletModules.SocialWallet, campaigns);

            if (response && this.onLoad) {
                this.ProcessList = await this.onLoad();

                this.PageNumber = 1;
                this.ApplyPagination();
            }
        }
    }

    // converte o index da linha dentro de ExcelData.slice(1) para o index real em ExcelData (usado nas chaves de CellErrorsMap)
    GetRowIndex(i: number): number {
        return i + 1;
    }

    HasCellError(rowIndex: number, colIndex: number): boolean {
        return this.CellErrorsMap.has(`${rowIndex}_${colIndex}`);
    }

    GetCellError(rowIndex: number, colIndex: number): string {
        return this.CellErrorsMap.get(`${rowIndex}_${colIndex}`) || '';
    }

    ChangeModule(e) {
        console.log(e);
        this.SelectedModule = e?.detail?.value || null;
    }

    Close() {
        // using the injected ModalController this page
        // can "dismiss" itself and optionally pass back data
        this.ModalController.dismiss(null, EnumGenericRoleActionAlerts.Close);
    }

    async OnView(ev: any, item) {

        ev?.preventDefault();
        ev?.stopPropagation();

        if (!item?.OutputFile?.Path) return;

        window.open(item?.OutputFile?.Path, '_blank');
    }

}
